module.exports = __webpack_public_path__ + "img/e12560e.jpg";